import { Language, languageToJSON } from '@enrollhere/classes';

export const languageMap: Partial<
  Record<Language, { title: string; image: string }>
> = {
  [Language.LANG_EN]: {
    title: 'English',
    image: '/assets/img/countries/us.svg',
  },
  [Language.LANG_ES]: {
    title: 'Spanish',
    image: '/assets/img/countries/es.svg',
  },
  [Language.LANG_FR]: {
    title: 'French',
    image: '/assets/img/countries/fr.svg',
  },
  [Language.LANG_AA]: { title: 'Afar', image: '/assets/img/countries/et.svg' },
  [Language.LANG_AB]: {
    title: 'Abkhazian',
    image: '/assets/img/countries/ge.svg',
  },
  [Language.LANG_AF]: {
    title: 'Afrikaans',
    image: '/assets/img/countries/za.svg',
  },
  [Language.LANG_AK]: { title: 'Akan', image: '/assets/img/countries/gh.svg' },
  [Language.LANG_SQ]: {
    title: 'Albanian',
    image: '/assets/img/countries/al.svg',
  },
  [Language.LANG_AM]: {
    title: 'Amharic',
    image: '/assets/img/countries/et.svg',
  },
  [Language.LANG_AR]: {
    title: 'Arabic',
    image: '/assets/img/countries/sa.svg',
  },
  [Language.LANG_AN]: {
    title: 'Aragonese',
    image: '/assets/img/countries/es.svg',
  },
  [Language.LANG_HY]: {
    title: 'Armenian',
    image: '/assets/img/countries/am.svg',
  },
  [Language.LANG_AS]: {
    title: 'Assamese',
    image: '/assets/img/countries/in.svg',
  },
  [Language.LANG_AV]: {
    title: 'Avaric',
    image: '/assets/img/countries/ru.svg',
  },
  [Language.LANG_AE]: {
    title: 'Avestan',
    image: '/assets/img/countries/af.svg',
  },
  [Language.LANG_AY]: {
    title: 'Aymara',
    image: '/assets/img/countries/bo.svg',
  },
  [Language.LANG_AZ]: {
    title: 'Azerbaijani',
    image: '/assets/img/countries/az.svg',
  },
  [Language.LANG_BM]: {
    title: 'Bambara',
    image: '/assets/img/countries/ml.svg',
  },
  [Language.LANG_BA]: {
    title: 'Bashkir',
    image: '/assets/img/countries/ru.svg',
  },
  [Language.LANG_EU]: {
    title: 'Basque',
    image: '/assets/img/countries/es-pv.svg',
  },
  [Language.LANG_BE]: {
    title: 'Belarusian',
    image: '/assets/img/countries/by.svg',
  },
  [Language.LANG_BN]: {
    title: 'Bengali',
    image: '/assets/img/countries/bd.svg',
  },
  [Language.LANG_BH]: {
    title: 'Bihari languages',
    image: '/assets/img/countries/in.svg',
  },
  [Language.LANG_BI]: {
    title: 'Bislama',
    image: '/assets/img/countries/vu.svg',
  },
  [Language.LANG_NB]: {
    title: 'Bokmål, Norwegian',
    image: '/assets/img/countries/no.svg',
  },
  [Language.LANG_BS]: {
    title: 'Bosnian',
    image: '/assets/img/countries/ba.svg',
  },
  [Language.LANG_BR]: {
    title: 'Breton',
    image: '/assets/img/countries/fr.svg',
  },
  [Language.LANG_BG]: {
    title: 'Bulgarian',
    image: '/assets/img/countries/bg.svg',
  },
  [Language.LANG_MY]: {
    title: 'Burmese',
    image: '/assets/img/countries/mm.svg',
  },
  [Language.LANG_CA]: {
    title: 'Catalan',
    image: '/assets/img/countries/es-ct.svg',
  },
  [Language.LANG_KM]: {
    title: 'Central Khmer',
    image: '/assets/img/countries/kh.svg',
  },
  [Language.LANG_CH]: {
    title: 'Chamorro',
    image: '/assets/img/countries/gu.svg',
  },
  [Language.LANG_CE]: {
    title: 'Chechen',
    image: '/assets/img/countries/ru.svg',
  },
  [Language.LANG_NY]: {
    title: 'Chichewa',
    image: '/assets/img/countries/mw.svg',
  },
  [Language.LANG_ZH]: {
    title: 'Chinese',
    image: '/assets/img/countries/cn.svg',
  },
  [Language.LANG_CU]: {
    title: 'Church Slavic',
    image: '/assets/img/countries/bg.svg',
  },
  [Language.LANG_CV]: {
    title: 'Chuvash',
    image: '/assets/img/countries/ru.svg',
  },
  [Language.LANG_KW]: {
    title: 'Cornish',
    image: '/assets/img/countries/gb-eng.svg',
  },
  [Language.LANG_CO]: {
    title: 'Corsican',
    image: '/assets/img/countries/fr.svg',
  },
  [Language.LANG_CR]: { title: 'Cree', image: '/assets/img/countries/ca.svg' },
  [Language.LANG_HR]: {
    title: 'Croatian',
    image: '/assets/img/countries/hr.svg',
  },
  [Language.LANG_CS]: { title: 'Czech', image: '/assets/img/countries/cz.svg' },
  [Language.LANG_DA]: {
    title: 'Danish',
    image: '/assets/img/countries/dk.svg',
  },
  [Language.LANG_DV]: {
    title: 'Divehi',
    image: '/assets/img/countries/mv.svg',
  },
  [Language.LANG_NL]: { title: 'Dutch', image: '/assets/img/countries/nl.svg' },
  [Language.LANG_DZ]: {
    title: 'Dzongkha',
    image: '/assets/img/countries/bt.svg',
  },
  [Language.LANG_EO]: {
    title: 'Esperanto',
    image: '/assets/img/countries/eu.svg',
  },
  [Language.LANG_ET]: {
    title: 'Estonian',
    image: '/assets/img/countries/ee.svg',
  },
  [Language.LANG_EE]: { title: 'Ewe', image: '/assets/img/countries/gh.svg' },
  [Language.LANG_FO]: {
    title: 'Faroese',
    image: '/assets/img/countries/fo.svg',
  },
  [Language.LANG_FJ]: {
    title: 'Fijian',
    image: '/assets/img/countries/fj.svg',
  },
  [Language.LANG_FI]: {
    title: 'Finnish',
    image: '/assets/img/countries/fi.svg',
  },
  [Language.LANG_FF]: { title: 'Fulah', image: '/assets/img/countries/sn.svg' },
  [Language.LANG_GD]: {
    title: 'Gaelic',
    image: '/assets/img/countries/gb-sct.svg',
  },
  [Language.LANG_GL]: {
    title: 'Galician',
    image: '/assets/img/countries/es-ga.svg',
  },
  [Language.LANG_LG]: { title: 'Ganda', image: '/assets/img/countries/ug.svg' },
  [Language.LANG_KA]: {
    title: 'Georgian',
    image: '/assets/img/countries/ge.svg',
  },
  [Language.LANG_DE]: {
    title: 'German',
    image: '/assets/img/countries/de.svg',
  },
  [Language.LANG_EL]: {
    title: 'Greek, Modern',
    image: '/assets/img/countries/gr.svg',
  },
  [Language.LANG_KL]: {
    title: 'Greenlandic',
    image: '/assets/img/countries/gl.svg',
  },
  [Language.LANG_GN]: {
    title: 'Guarani',
    image: '/assets/img/countries/py.svg',
  },
  [Language.LANG_GU]: {
    title: 'Gujarati',
    image: '/assets/img/countries/in.svg',
  },
  [Language.LANG_HT]: {
    title: 'Haitian',
    image: '/assets/img/countries/ht.svg',
  },
  [Language.LANG_HA]: { title: 'Hausa', image: '/assets/img/countries/ng.svg' },
  [Language.LANG_HE]: {
    title: 'Hebrew',
    image: '/assets/img/countries/il.svg',
  },
  [Language.LANG_HZ]: {
    title: 'Herero',
    image: '/assets/img/countries/na.svg',
  },
  [Language.LANG_HI]: { title: 'Hindi', image: '/assets/img/countries/in.svg' },
  [Language.LANG_HO]: {
    title: 'Hiri Motu',
    image: '/assets/img/countries/pg.svg',
  },
  [Language.LANG_HU]: {
    title: 'Hungarian',
    image: '/assets/img/countries/hu.svg',
  },
  [Language.LANG_IS]: {
    title: 'Icelandic',
    image: '/assets/img/countries/is.svg',
  },
  [Language.LANG_IO]: { title: 'Ido', image: '/assets/img/countries/eu.svg' },
  [Language.LANG_IG]: { title: 'Igbo', image: '/assets/img/countries/ng.svg' },
  [Language.LANG_ID]: {
    title: 'Indonesian',
    image: '/assets/img/countries/id.svg',
  },
  [Language.LANG_IA]: {
    title: 'Interlingua',
    image: '/assets/img/countries/eu.svg',
  },
  [Language.LANG_IE]: {
    title: 'Interlingue',
    image: '/assets/img/countries/eu.svg',
  },
  [Language.LANG_IU]: {
    title: 'Inuktitut',
    image: '/assets/img/countries/ca.svg',
  },
  [Language.LANG_IK]: {
    title: 'Inupiaq',
    image: '/assets/img/countries/us.svg',
  },
  [Language.LANG_GA]: { title: 'Irish', image: '/assets/img/countries/ie.svg' },
  [Language.LANG_IT]: {
    title: 'Italian',
    image: '/assets/img/countries/it.svg',
  },
  [Language.LANG_JA]: {
    title: 'Japanese',
    image: '/assets/img/countries/jp.svg',
  },
  [Language.LANG_JV]: {
    title: 'Javanese',
    image: '/assets/img/countries/id.svg',
  },
  [Language.LANG_KN]: {
    title: 'Kannada',
    image: '/assets/img/countries/in.svg',
  },
  [Language.LANG_KR]: {
    title: 'Kanuri',
    image: '/assets/img/countries/ng.svg',
  },
  [Language.LANG_KS]: {
    title: 'Kashmiri',
    image: '/assets/img/countries/in.svg',
  },
  [Language.LANG_KK]: {
    title: 'Kazakh',
    image: '/assets/img/countries/kz.svg',
  },
  [Language.LANG_KI]: {
    title: 'Kikuyu',
    image: '/assets/img/countries/ke.svg',
  },
  [Language.LANG_RW]: {
    title: 'Kinyarwanda',
    image: '/assets/img/countries/rw.svg',
  },
  [Language.LANG_KY]: {
    title: 'Kirghiz',
    image: '/assets/img/countries/kg.svg',
  },
  [Language.LANG_KV]: { title: 'Komi', image: '/assets/img/countries/ru.svg' },
  [Language.LANG_KG]: { title: 'Kongo', image: '/assets/img/countries/cd.svg' },
  [Language.LANG_KO]: {
    title: 'Korean',
    image: '/assets/img/countries/kr.svg',
  },
  [Language.LANG_KJ]: {
    title: 'Kuanyama',
    image: '/assets/img/countries/ao.svg',
  },
  [Language.LANG_KU]: {
    title: 'Kurdish',
    image: '/assets/img/countries/iq.svg',
  },
  [Language.LANG_LO]: { title: 'Lao', image: '/assets/img/countries/la.svg' },
  [Language.LANG_LA]: { title: 'Latin', image: '/assets/img/countries/va.svg' },
  [Language.LANG_LV]: {
    title: 'Latvian',
    image: '/assets/img/countries/lv.svg',
  },
  [Language.LANG_LI]: {
    title: 'Limburgan',
    image: '/assets/img/countries/nl.svg',
  },
  [Language.LANG_LN]: {
    title: 'Lingala',
    image: '/assets/img/countries/cd.svg',
  },
  [Language.LANG_LT]: {
    title: 'Lithuanian',
    image: '/assets/img/countries/lt.svg',
  },
  [Language.LANG_LU]: {
    title: 'Luba-Katanga',
    image: '/assets/img/countries/cd.svg',
  },
  [Language.LANG_LB]: {
    title: 'Luxembourgish',
    image: '/assets/img/countries/lu.svg',
  },
  [Language.LANG_MK]: {
    title: 'Macedonian',
    image: '/assets/img/countries/mk.svg',
  },
  [Language.LANG_MG]: {
    title: 'Malagasy',
    image: '/assets/img/countries/mg.svg',
  },
  [Language.LANG_MS]: { title: 'Malay', image: '/assets/img/countries/my.svg' },
  [Language.LANG_ML]: {
    title: 'Malayalam',
    image: '/assets/img/countries/in.svg',
  },
  [Language.LANG_MT]: {
    title: 'Maltese',
    image: '/assets/img/countries/mt.svg',
  },
  [Language.LANG_GV]: { title: 'Manx', image: '/assets/img/countries/im.svg' },
  [Language.LANG_MI]: { title: 'Maori', image: '/assets/img/countries/nz.svg' },
  [Language.LANG_MR]: {
    title: 'Marathi',
    image: '/assets/img/countries/in.svg',
  },
  [Language.LANG_MH]: {
    title: 'Marshallese',
    image: '/assets/img/countries/mh.svg',
  },
  [Language.LANG_MN]: {
    title: 'Mongolian',
    image: '/assets/img/countries/mn.svg',
  },
  [Language.LANG_NA]: { title: 'Nauru', image: '/assets/img/countries/nr.svg' },
  [Language.LANG_NV]: {
    title: 'Navajo',
    image: '/assets/img/countries/us.svg',
  },
  [Language.LANG_ND]: {
    title: 'Ndebele, North',
    image: '/assets/img/countries/zw.svg',
  },
  [Language.LANG_NR]: {
    title: 'Ndebele, South',
    image: '/assets/img/countries/za.svg',
  },
  [Language.LANG_NG]: {
    title: 'Ndonga',
    image: '/assets/img/countries/na.svg',
  },
  [Language.LANG_NE]: {
    title: 'Nepali',
    image: '/assets/img/countries/np.svg',
  },
  [Language.LANG_SE]: {
    title: 'Northern Sami',
    image: '/assets/img/countries/no.svg',
  },
  [Language.LANG_NO]: {
    title: 'Norwegian',
    image: '/assets/img/countries/no.svg',
  },
  [Language.LANG_NN]: {
    title: 'Norwegian Nynorsk',
    image: '/assets/img/countries/no.svg',
  },
  [Language.LANG_OC]: {
    title: 'Occitan',
    image: '/assets/img/countries/fr.svg',
  },
  [Language.LANG_OJ]: {
    title: 'Ojibwa',
    image: '/assets/img/countries/ca.svg',
  },
  [Language.LANG_OR]: { title: 'Oriya', image: '/assets/img/countries/in.svg' },
  [Language.LANG_OM]: { title: 'Oromo', image: '/assets/img/countries/et.svg' },
  [Language.LANG_OS]: {
    title: 'Ossetian',
    image: '/assets/img/countries/ge.svg',
  },
  [Language.LANG_PI]: { title: 'Pali', image: '/assets/img/countries/lk.svg' },
  [Language.LANG_PA]: {
    title: 'Panjabi',
    image: '/assets/img/countries/in.svg',
  },
  [Language.LANG_FA]: {
    title: 'Persian',
    image: '/assets/img/countries/ir.svg',
  },
  [Language.LANG_PL]: {
    title: 'Polish',
    image: '/assets/img/countries/pl.svg',
  },
  [Language.LANG_PT]: {
    title: 'Portuguese',
    image: '/assets/img/countries/pt.svg',
  },
  [Language.LANG_PS]: {
    title: 'Pushto',
    image: '/assets/img/countries/af.svg',
  },
  [Language.LANG_QU]: {
    title: 'Quechua',
    image: '/assets/img/countries/pe.svg',
  },
  [Language.LANG_RM]: {
    title: 'Romansh',
    image: '/assets/img/countries/ch.svg',
  },
  [Language.LANG_RO]: {
    title: 'Romanian',
    image: '/assets/img/countries/ro.svg',
  },
  [Language.LANG_RN]: { title: 'Rundi', image: '/assets/img/countries/bi.svg' },
  [Language.LANG_RU]: {
    title: 'Russian',
    image: '/assets/img/countries/ru.svg',
  },
  [Language.LANG_SM]: {
    title: 'Samoan',
    image: '/assets/img/countries/ws.svg',
  },
  [Language.LANG_SG]: { title: 'Sango', image: '/assets/img/countries/cf.svg' },
  [Language.LANG_SA]: {
    title: 'Sanskrit',
    image: '/assets/img/countries/in.svg',
  },
  [Language.LANG_SC]: {
    title: 'Sardinian',
    image: '/assets/img/countries/it.svg',
  },
  [Language.LANG_SR]: {
    title: 'Serbian',
    image: '/assets/img/countries/rs.svg',
  },
  [Language.LANG_SN]: { title: 'Shona', image: '/assets/img/countries/zw.svg' },
  [Language.LANG_II]: {
    title: 'Sichuan Yi',
    image: '/assets/img/countries/cn.svg',
  },
  [Language.LANG_SD]: {
    title: 'Sindhi',
    image: '/assets/img/countries/pk.svg',
  },
  [Language.LANG_SI]: {
    title: 'Sinhala',
    image: '/assets/img/countries/lk.svg',
  },
  [Language.LANG_SK]: {
    title: 'Slovak',
    image: '/assets/img/countries/sk.svg',
  },
  [Language.LANG_SL]: {
    title: 'Slovenian',
    image: '/assets/img/countries/si.svg',
  },
  [Language.LANG_SO]: {
    title: 'Somali',
    image: '/assets/img/countries/so.svg',
  },
  [Language.LANG_ST]: {
    title: 'Sotho, Southern',
    image: '/assets/img/countries/ls.svg',
  },
  [Language.LANG_SU]: {
    title: 'Sundanese',
    image: '/assets/img/countries/id.svg',
  },
  [Language.LANG_SW]: {
    title: 'Swahili',
    image: '/assets/img/countries/ke.svg',
  },
  [Language.LANG_SS]: { title: 'Swati', image: '/assets/img/countries/sz.svg' },
  [Language.LANG_SV]: {
    title: 'Swedish',
    image: '/assets/img/countries/se.svg',
  },
  [Language.LANG_TL]: {
    title: 'Tagalog',
    image: '/assets/img/countries/ph.svg',
  },
  [Language.LANG_TY]: {
    title: 'Tahitian',
    image: '/assets/img/countries/pf.svg',
  },
  [Language.LANG_TG]: { title: 'Tajik', image: '/assets/img/countries/tj.svg' },
  [Language.LANG_TA]: { title: 'Tamil', image: '/assets/img/countries/lk.svg' },
  [Language.LANG_TT]: { title: 'Tatar', image: '/assets/img/countries/ru.svg' },
  [Language.LANG_TE]: {
    title: 'Telugu',
    image: '/assets/img/countries/in.svg',
  },
  [Language.LANG_TH]: { title: 'Thai', image: '/assets/img/countries/th.svg' },
  [Language.LANG_BO]: {
    title: 'Tibetan',
    image: '/assets/img/countries/bt.svg',
  },
  [Language.LANG_TI]: {
    title: 'Tigrinya',
    image: '/assets/img/countries/er.svg',
  },
  [Language.LANG_TO]: { title: 'Tonga', image: '/assets/img/countries/to.svg' },
  [Language.LANG_TS]: {
    title: 'Tsonga',
    image: '/assets/img/countries/za.svg',
  },
  [Language.LANG_TN]: {
    title: 'Tswana',
    image: '/assets/img/countries/bw.svg',
  },
  [Language.LANG_TR]: {
    title: 'Turkish',
    image: '/assets/img/countries/tr.svg',
  },
  [Language.LANG_TK]: {
    title: 'Turkmen',
    image: '/assets/img/countries/tm.svg',
  },
  [Language.LANG_TW]: { title: 'Twi', image: '/assets/img/countries/gh.svg' },
  [Language.LANG_UG]: {
    title: 'Uighur',
    image: '/assets/img/countries/cn.svg',
  },
  [Language.LANG_UK]: {
    title: 'Ukrainian',
    image: '/assets/img/countries/ua.svg',
  },
  [Language.LANG_UR]: { title: 'Urdu', image: '/assets/img/countries/pk.svg' },
  [Language.LANG_UZ]: { title: 'Uzbek', image: '/assets/img/countries/uz.svg' },
  [Language.LANG_VE]: { title: 'Venda', image: '/assets/img/countries/za.svg' },
  [Language.LANG_VI]: {
    title: 'Vietnamese',
    image: '/assets/img/countries/vn.svg',
  },
  [Language.LANG_VO]: {
    title: 'Volapük',
    image: '/assets/img/countries/eu.svg',
  },
  [Language.LANG_WA]: {
    title: 'Walloon',
    image: '/assets/img/countries/be.svg',
  },
  [Language.LANG_CY]: {
    title: 'Welsh',
    image: '/assets/img/countries/gb-wls.svg',
  },
  [Language.LANG_FY]: {
    title: 'Western Frisian',
    image: '/assets/img/countries/nl.svg',
  },
  [Language.LANG_WO]: { title: 'Wolof', image: '/assets/img/countries/sn.svg' },
  [Language.LANG_XH]: { title: 'Xhosa', image: '/assets/img/countries/za.svg' },
  [Language.LANG_YI]: {
    title: 'Yiddish',
    image: '/assets/img/countries/il.svg',
  },
  [Language.LANG_YO]: {
    title: 'Yoruba',
    image: '/assets/img/countries/ng.svg',
  },
  [Language.LANG_ZA]: {
    title: 'Zhuang',
    image: '/assets/img/countries/cn.svg',
  },
  [Language.LANG_ZU]: { title: 'Zulu', image: '/assets/img/countries/za.svg' },
};

export const languageList = Object.entries(languageMap)
  .filter(
    (entry): entry is [string, { title: string; image: string }] =>
      entry[1] != null
  )
  .map(([key, value]) => ({
    id: parseInt(key) as Language,
    title: value.title,
    image: value.image,
  }));

export const languageLabelMap = Object.fromEntries(
  Object.entries(languageMap)
    .filter(
      (entry): entry is [string, { title: string; image: string }] =>
        entry[1] != null
    )
    .map(([key, value]) => [languageToJSON(parseInt(key) as Language), value])
) as Record<string, { title: string; image?: string }>;

export const getLanguageLabel = (
  language: Language | string | number | undefined | null
): string | undefined => {
  if (language === undefined || language === null || language === '') {
    return undefined;
  }

  if (typeof language === 'number') {
    return languageMap[language as Language]?.title;
  }

  if (typeof language === 'string' && languageLabelMap[language]) {
    return languageLabelMap[language].title;
  }

  const numericLanguage = Number(language);
  if (!Number.isNaN(numericLanguage)) {
    return languageMap[numericLanguage as Language]?.title;
  }

  return typeof language === 'string' ? language : undefined;
};
